/**
 * CredentialsTab - Wrapper for credentials management in agent drawer
 *
 * Provides Active Directory credential management for agents to enable
 * authenticated security scanning capabilities. Available to all users.
 */

import React from 'react';

import type { Agent } from '@/hooks/useAgents';
import { CredentialsManagementTab } from '@/sections/agents/components/aegis-management/credentials/CredentialsManagementTab';

interface CredentialsTabProps {
  agent: Agent;
}

export const CredentialsTab: React.FC<CredentialsTabProps> = ({ agent }) => {
  return (
    <div
      className="flex h-full flex-col"
      data-testid="agent-drawer-credentials-tab"
    >
      <CredentialsManagementTab agent={agent} />
    </div>
  );
};
